// extracted by mini-css-extract-plugin
module.exports = {"burger":"burger_burger__33Eei","cross":"burger_cross__2XbiH","crossopen":"burger_crossopen__29bKW","open":"burger_open__3KRoj"};